"use strict";

var _jquery = require("jquery");
var _jquery2 = _interopRequireDefault(_jquery);
require("bootstrap");
require("slick-carousel");
require("./scss/frontend/style.scss");
require("./js/_cookies");
require("./js/_section-banner-slider");
require("./js/_section-sku-slider");
require("./js/_section-banner-slider-offset-bottom");
require("./js/_section-banner-slider-1-5");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
window.jQuery = _jquery2.default;
window.$ = _jquery2.default;
(0, _jquery2.default)(function () {
  (0, _jquery2.default)(document).on('click', '.inner-link', function () {
    var href = (0, _jquery2.default)(this).attr('href');
    var width = (0, _jquery2.default)(window).width();
    var offset = width > 720 ? 100 : 60;
    var $target = (0, _jquery2.default)(href);
    (0, _jquery2.default)('.navbar-collapse').collapse('hide');
    (0, _jquery2.default)('html, body').animate({
      scrollTop: (0, _jquery2.default)(href).offset().top - offset
    }, {
      duration: 1000,
      easing: "linear",
      step: function step(now, fx) {
        var offset = width > 720 ? 100 : 60;
        var newOffset = $target.offset().top - offset;
        if (fx.end !== newOffset) fx.end = newOffset;
      }
    });
  });
  /*
  var tagArrowLeft = $('.slider-homepage').data('tag-arrow-left');
  var tagArrowRight = $('.slider-homepage').data('tag-arrow-right');
  $('.slider-homepage').on('init', function (event, slick, direction) {
      $('.slider-homepage .slick-slide a').each(function (index, element) {
          var id = $(element).data('id');
          $(element).attr('id', id);
      });
  });
  $('.slider-homepage').slick({
      dots: true,
      arrows: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      prevArrow: "<button class='slick-prev slick-arrow' aria-label='Previous' type='button' style='' id='" + tagArrowLeft + "'><div class='arrow'></div>Previous</button>",
      nextArrow: "<button class='slick-next slick-arrow' aria-label='Next' type='button' style='' id='" + tagArrowRight + "'><div class='arrow'></div>Next</button>",
      appendDots: '#container-dots-homepage',
      appendArrows: '#container-arrows-homepage',
  });
  */
});